import React, { Component } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';

class ASRGroupDialog extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      groupName: ''
    };

    this.onChangeGroupName = this.onChangeGroupName.bind( this );
    this.onClickSaveButton = this.onClickSaveButton.bind( this );
  }

  onChangeGroupName( e ) {
    this.setState( {
      groupName: e.target.value
    } );
  }

  onClickSaveButton( e ) {
    const newGroupName = {
      ASR_Group_Name_ID: -1,
      Group_Name: this.state.groupName
    };

    this.props.onSave( newGroupName );
  }

  onRenderBody() {
    return (
      <div className='asr-group-dialog-body'>
        <div className='asr-group-dialog-body-row-1'>
          <span className='asr-group-dialog-body-row-1-col-1'>
            <span className='asr-group-dialog-group-name-label'>
              Group Name:
            </span>
          </span>
          <span className='asr-group-dialog-body-row-1-col-2'>
            <input className='asr-group-dialog-group-name-input' type='text' value={this.state.groupName} onChange={this.onChangeGroupName} />
          </span>
        </div>
      </div>
    );
  }

  onRenderFooter() {
    return (
      <span className='asr-dialog-footer'>
        <button className='asr-dialog-footer-cancel-button' onClick={this.props.onClose}>
          Cancel
        </button>
        <button className='asr-dialog-footer-save-button' onClick={this.onClickSaveButton}>
          Save
        </button>
      </span>
    );
  }

  render() {
    return (
      <Dialog show={this.props.show} width={20} height={20} >
        <DialogHeader caption={'Add New Group'} closeButton onClose={this.props.onClose} />
        <DialogBody>
          {this.onRenderBody()}
        </DialogBody>
        <DialogFooter>
          {this.onRenderFooter()}
        </DialogFooter>
      </Dialog>
    );
  }
}

export default ASRGroupDialog;


// WEBPACK FOOTER //
// ./src/content/enterprise/asr/components/ASRGroupDialog.js